export const DotRedirectLinks = {
  HelpDecideBudget: 'https://dotaudiences.com/support?article=deciding-your-advertising-budget',
  cryptoPaymentLink: 'https://dotaudiences.com/support?article=how-to-top-up-your-balance-with-cryptocurrency',
  ClaimFreeBenefits: 'https://dotaudiences.com/support'
}